import { render, staticRenderFns } from "./m-brand-plank.vue?vue&type=template&id=57bd67f9&scoped=true&"
import script from "./m-brand-plank.vue?vue&type=script&lang=js&"
export * from "./m-brand-plank.vue?vue&type=script&lang=js&"
import style0 from "./m-brand-plank.vue?vue&type=style&index=0&id=57bd67f9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bd67f9",
  null
  
)

export default component.exports